export const SET_LOADER = 'loader/SET_LOADER';